import { UseControllerProps, useController } from "react-hook-form";
import { Flex, Input, Typography } from "@payping/web-components";
import { InputSearchProps } from "@payping/web-components/components/Input/types";

type Props = InputSearchProps &
  UseControllerProps<any> & {
    label?: React.ReactNode | string;
    labelClassName?: string;
  };

const RHFInputSearch: React.FC<Props> = ({
  name,
  control,
  defaultValue = "",
  rules,
  shouldUnregister,
  label,
  labelClassName,
  ...rest
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <Flex vertical className="tw-relative tw-pb-[28px]">
      {label && <Typography.Text className={`tw-mb-[8px] !tw-text-[14px] ${labelClassName}`}>{label}</Typography.Text>}
      <Input.Search {...field} {...rest} status={error ? "error" : ""} />
      {error && (
        <Typography.Text type="danger" className="tw-absolute tw-bottom-[2px] tw-start-0">
          {error.message}
        </Typography.Text>
      )}
    </Flex>
  );
};

export default RHFInputSearch;
